/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ItineratorError, ItineratorPlatformExtension, ItineratorPlatformExtensionList } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class PlatformExtensions<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags PlatformExtension
   * @name GetPlatformExtensions
   * @summary List all platform extensions
   * @request GET:/platform_extensions
   * @secure
   */
  getPlatformExtensions = (params: RequestParams = {}) =>
    this.request<ItineratorPlatformExtensionList, ItineratorError>({
      path: `/platform_extensions`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PlatformExtension
   * @name GetPlatformExtensionBySlug
   * @summary Find a platform extension by slug
   * @request GET:/platform_extensions/{slug}
   * @secure
   */
  getPlatformExtensionBySlug = (slug: string | number, params: RequestParams = {}) =>
    this.request<ItineratorPlatformExtension, ItineratorError>({
      path: `/platform_extensions/${slug}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
